import { Select, Form } from 'antd';
import { sortBy } from 'lodash';
import React, { Component } from 'react';
import BrandApi from '../../../functions/api/vehicle/BrandApi';

export default class SelectBrands extends Component {
  constructor(props) {
    super(props);
    this.state = {
      brands: [],
    };
  }

  componentDidMount = async () => {
    const { vehicleType } = this.props;
    const brands = await BrandApi.getBrandByType(vehicleType);
    this.setState({
      brands,
    });
  };

  onBrandChange = (newBrand) => {
    const { onBrandChange, onChange } = this.props;

    onBrandChange?.(newBrand);
    onChange?.(newBrand);
  };

  render() {
    const { brands } = this.state;
    const { disabled, value } = this.props;
    return (
      <Select
        showSearch
        filterOption={(input, option) =>
          option.label.toLowerCase().includes(input.toLowerCase())
        }
        options={sortBy(brands, ['vhc_bran_name']).map((b) => ({
          value: b.vhc_bran_id,
          label: b.vhc_bran_name,
        }))}
        defaultValue={this.props.selected}
        value={value}
        onChange={this.onBrandChange}
        disabled={disabled}
      />
    );
  }
}
